import { CHANGE_SERVICE_CARD, GET_SERVICE_CARD_CONFIG, SET_EMAIL_SUBJECT } from '../constants/constants'

export const changeServiceCard = (cardTitle) => (dispatch) => {
    dispatch({ type: CHANGE_SERVICE_CARD, payload: cardTitle })
}

export const getServiceCardConfig = () => (dispatch) => {
    dispatch({ type: GET_SERVICE_CARD_CONFIG })
}
